import styled from 'styled-components'

import { CurrencyIcon } from '@root/entities/currency/ui'
import { DomUtil } from '@root/shared'
import { RectangleNetworkBackgroundGradient } from '@root/shared/ui'

import FALLBACK_BG from './assets/fallback-bg.inline.svg'

import type { ImageHash } from '@root/entities/currency'
import type { PairModel } from '@root/entities/pair'
import type { ChildrenProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  iconSrcOverride?: string | undefined
  bannerSrcOverride?: string | undefined
  imageHashOverride?: ImageHash | undefined
} & ChildrenProps

export const CurrencyBannerFallback: React.FC<Props> = ({
  pair,
  children,
  iconSrcOverride,
  bannerSrcOverride,
  imageHashOverride,
}) => (
  <Root>
    {children}
    <Frame>
      <CurrencyIcon
        size={68}
        iconSrcOverride={iconSrcOverride}
        bannerSrcOverride={bannerSrcOverride}
        currency={pair.quote}
        premiumInfo={pair.premiumInfo}
        withPreview
        imageHashOverride={imageHashOverride}
        reusedImages={{ side: 'left' }}
      />
    </Frame>
  </Root>
)

const Root = styled.div`
  height: 100%;
  width: 100%;

  display: grid;
  justify-content: center;
  align-items: start;
  padding-top: 12px;
  background-image:
    radial-gradient(
      80% 130% at 75% -20%,
      rgba(var(--primary-9-rgb), 0.9) 0%,
      rgba(var(--primary-8-rgb), 0.8) 35%,
      transparent 85%
    ),
    radial-gradient(
      55% 110% at 40% 120%,
      rgba(var(--primary-9-rgb), 0.9) 0%,
      rgba(var(--primary-8-rgb), 0.8) 35%,
      transparent 85%
    ),
    ${RectangleNetworkBackgroundGradient};
  /* background-image: ${DomUtil.cssUrl(FALLBACK_BG)}; */
  position: relative;
`

const Frame = styled.div`
  border-radius: 10px;
  border: 1px solid rgba(var(--appearance-inv-1-rgb), 0.09);
  background: rgba(var(--appearance-inv-1-rgb), 0.06);
  backdrop-filter: blur(6px);

  width: 74px;
  height: 74px;
  position: relative;
  display: grid;
  align-items: center;
  justify-content: center;
`
